import { T as o, _ as c, s as u } from "./directive-B76A7YXI-CvGfmxqC.js";
import { u as s, T as a } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends c {
  constructor(r) {
    if (super(r), this.it = s, r.type !== u.CHILD)
      throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(r) {
    if (r === s || r == null)
      return this._t = void 0, this.it = r;
    if (r === a)
      return r;
    if (typeof r != "string")
      throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (r === this.it)
      return this._t;
    this.it = r;
    const t = [r];
    return t.raw = t, this._t = { _$litType$: this.constructor.resultType, strings: t, values: [] };
  }
}
e.directiveName = "unsafeHTML", e.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class i extends e {
}
i.directiveName = "unsafeSVG", i.resultType = 2;
const d = o(i);
export {
  d
};
